const secondaryProductData = {
    "Regular Pallet": "45371400880302",
    "Grass Pallet": "45371411136686",
    "default": "45371400880302"
};

async function applyCartUpdates(updates) {
    console.log("[applyCartUpdates] Applying Updates to Cart:", updates);

    try {
        const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
        });

        if (!res.ok) {
            throw new Error("Failed to apply cart updates.");
        }

        console.log("[applyCartUpdates] Cart updates applied successfully.");
        return await res.json();
    } catch (error) {
        console.error("[applyCartUpdates] Error applying updates:", error);
    }
}

window.calculateAndAdjustQuantities = async function (updates) {
    console.log("[calculateAndAdjustQuantities] Received Updates Array:", updates);

    if (!updates || updates.length === 0) {
        console.warn("[calculateAndAdjustQuantities] No updates provided. Returning original updates.");
        return updates;
    }

    const items = document.querySelectorAll("[data-item-key]");
    if (items.length === 0) {
        console.warn("[calculateAndAdjustQuantities] No items found in the cart.");
        return updates;
    }

    console.log("[calculateAndAdjustQuantities] Cart Items Found:", items);

    const secondaryProductQuantities = {};
    const processedSecondaryKeys = new Set();
    let adjustmentsMade = false;

    const removedItems = updates.filter(update => parseInt(update.quantity, 10) === 0).map(update => update.key.split(':')[0]);

    items.forEach((item) => {
        const isSecondary = item.dataset.isSecondary;
        console.log("[calculateAndAdjustQuantities] Processing Item:", item);

        if (isSecondary === "true") {
            console.log("[calculateAndAdjustQuantities] Skipping Secondary Product:", item);
            return;
        }

        const itemKey = item.dataset.itemKey.split(':')[0];
        const palletProductMetafield = item.dataset.palletProduct;
        const secondaryProductId = secondaryProductData[palletProductMetafield] || secondaryProductData["default"];

        console.log("[calculateAndAdjustQuantities] Pallet Product Metafield:", palletProductMetafield);
        console.log("[calculateAndAdjustQuantities] Secondary Product ID:", secondaryProductId);

        if (!palletProductMetafield || !secondaryProductId) {
            console.log("[calculateAndAdjustQuantities] Missing or Invalid Pallet Product Metafield. Skipping Item:", itemKey);
            return;
        }

        if (removedItems.includes(itemKey)) {
            console.log("[calculateAndAdjustQuantities] Skipping Removed Primary Product:", itemKey);
            return;
        }

        const primaryQuantityInput = item.querySelector("input[name='updates[]']");
        let primaryQuantity = 0;
        const updateFromUpdatesArray = updates.find(update => update.key === item.dataset.itemKey);

        if (updateFromUpdatesArray) {
            primaryQuantity = parseInt(updateFromUpdatesArray.quantity, 10);
        } else if (primaryQuantityInput) {
            primaryQuantity = parseInt(primaryQuantityInput.value, 10);
        }

        if (isNaN(primaryQuantity)) {
            console.warn("[calculateAndAdjustQuantities] Primary quantity is NaN. Setting to 0:", primaryQuantity);
            primaryQuantity = 0;
        }

        let palletQtyMetafield = parseInt(item.dataset.variantPalletQty, 10);
        if (isNaN(palletQtyMetafield) || palletQtyMetafield <= 0) {
            palletQtyMetafield = parseInt(item.dataset.palletQty, 10);
        }

        if (!isNaN(palletQtyMetafield) && palletQtyMetafield > 0 && primaryQuantity > 0) {
            const additionalQuantity = Math.ceil(primaryQuantity / palletQtyMetafield);

            if (secondaryProductQuantities[secondaryProductId]) {
                secondaryProductQuantities[secondaryProductId] += additionalQuantity;
            } else {
                secondaryProductQuantities[secondaryProductId] = additionalQuantity;
            }

            adjustmentsMade = true;
        } else {
            console.log("[calculateAndAdjustQuantities] Missing or Invalid Pallet Quantity Metafield. Skipping Item:", itemKey);
        }
    });

    items.forEach((item) => {
        const isSecondary = item.dataset.isSecondary;

        if (isSecondary === "true") {
            const secondaryProductId = item.getAttribute('variant-id') || item.dataset.palletProduct;

            if (secondaryProductQuantities.hasOwnProperty(secondaryProductId) && !processedSecondaryKeys.has(item.dataset.itemKey)) {
                const newQuantity = secondaryProductQuantities[secondaryProductId] || 0;

                updates.push({
                    key: item.dataset.itemKey,
                    quantity: `${newQuantity}`,
                    selling_plan: item.dataset.sellingPlan || ''
                });
                console.log("[calculateAndAdjustQuantities] Updated Secondary Product:", {
                    key: item.dataset.itemKey,
                    quantity: newQuantity,
                    selling_plan: item.dataset.sellingPlan || ''
                });

                processedSecondaryKeys.add(item.dataset.itemKey);
                adjustmentsMade = true;
            } else if (!secondaryProductQuantities.hasOwnProperty(secondaryProductId)) {
                updates.push({
                    key: item.dataset.itemKey,
                    quantity: "0",
                    selling_plan: item.dataset.sellingPlan || ''
                });
                console.log("[calculateAndAdjustQuantities] Removing Secondary Product:", {
                    key: item.dataset.itemKey,
                    quantity: "0",
                    selling_plan: item.dataset.sellingPlan || ''
                });

                processedSecondaryKeys.add(item.dataset.itemKey);
                adjustmentsMade = true;
            }
        }
    });

    if (!adjustmentsMade) {
        console.log("[calculateAndAdjustQuantities] No secondary product adjustments needed. Returning original updates.");
        return updates;
    }

    console.log("[calculateAndAdjustQuantities] Final Updates Array:", updates);

    if (adjustmentsMade) {
        document.body.classList.add('cart-updating');
        await applyCartUpdates(updates);
        document.body.classList.remove('cart-updating');
    }

    return updates;
};
